
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
  <path
    d="M7,14a7,7,0,1,1,7-7A7,7,0,0,1,7,14ZM6.625,6a.125.125,0,0,0-.125.125v4.25a.125.125,0,0,0,.125.125h.75a.125.125,0,0,0,.125-.125V6.125A.125.125,0,0,0,7.375,6ZM7,3.5a.75.75,0,1,0,.75.75A.75.75,0,0,0,7,3.5Z"
    transform="translate(1 1)"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Info',
    }) as DefineComponent
    </script>
    